<template>
  <div class="widget-carousel-text-settings card border-0 shadow-sm compact-form-card">
    <div class="card-header bg-white border-bottom compact-form-card__header">
      <strong>Conținut text</strong>
    </div>

    <div class="card-body compact-form-card__body">
      <div class="widget-carousel-text-settings__section">
        <h5 class="widget-carousel-text-settings__section-title">
          Title
        </h5>

        <div class="form-row compact-form-row">
          <div class="form-group col-12 col-md-6 compact-form-group">
            <label for="widget-carousel-title-ro" class="compact-label">RO</label>
            <input
                id="widget-carousel-title-ro"
                type="text"
                class="form-control compact-input"
                maxlength="100"
                :disabled="!form.is_active"
                :value="form.title.ro"
                @input="updateI18nField('title', 'ro', $event.target.value)"
            >
            <div class="compact-meta">
              <small class="compact-counter">
                {{ getLength(form.title.ro) }} / 100
              </small>
              <small
                  v-if="isAtLimit(form.title.ro)"
                  class="compact-error"
              >
                Ai atins limita maximă de 100 de caractere.
              </small>
            </div>
          </div>

          <div class="form-group col-12 col-md-6 compact-form-group">
            <label for="widget-carousel-title-en" class="compact-label">EN</label>
            <input
                id="widget-carousel-title-en"
                type="text"
                class="form-control compact-input"
                maxlength="100"
                :disabled="!form.is_active"
                :value="form.title.en"
                @input="updateI18nField('title', 'en', $event.target.value)"
            >
            <div class="compact-meta">
              <small class="compact-counter">
                {{ getLength(form.title.en) }} / 100
              </small>
              <small
                  v-if="isAtLimit(form.title.en)"
                  class="compact-error"
              >
                Ai atins limita maximă de 100 de caractere.
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="widget-carousel-text-settings__section">
        <h5 class="widget-carousel-text-settings__section-title">
          Subtitle
        </h5>

        <div class="form-row compact-form-row">
          <div class="form-group col-12 col-md-6 compact-form-group">
            <label for="widget-carousel-subtitle-ro" class="compact-label">RO</label>
            <input
                id="widget-carousel-subtitle-ro"
                type="text"
                class="form-control compact-input"
                maxlength="100"
                :disabled="!form.is_active"
                :value="form.subtitle.ro"
                @input="updateI18nField('subtitle', 'ro', $event.target.value)"
            >
            <div class="compact-meta">
              <small class="compact-counter">
                {{ getLength(form.subtitle.ro) }} / 100
              </small>
              <small
                  v-if="isAtLimit(form.subtitle.ro)"
                  class="compact-error"
              >
                Ai atins limita maximă de 100 de caractere.
              </small>
            </div>
          </div>

          <div class="form-group col-12 col-md-6 compact-form-group">
            <label for="widget-carousel-subtitle-en" class="compact-label">EN</label>
            <input
                id="widget-carousel-subtitle-en"
                type="text"
                class="form-control compact-input"
                maxlength="100"
                :disabled="!form.is_active"
                :value="form.subtitle.en"
                @input="updateI18nField('subtitle', 'en', $event.target.value)"
            >
            <div class="compact-meta">
              <small class="compact-counter">
                {{ getLength(form.subtitle.en) }} / 100
              </small>
              <small
                  v-if="isAtLimit(form.subtitle.en)"
                  class="compact-error"
              >
                Ai atins limita maximă de 100 de caractere.
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="widget-carousel-text-settings__section mb-0">
        <h5 class="widget-carousel-text-settings__section-title">
          Footer
        </h5>

        <div class="form-row compact-form-row">
          <div class="form-group col-12 col-md-6 compact-form-group">
            <label for="widget-carousel-footer-ro" class="compact-label">RO</label>
            <input
                id="widget-carousel-footer-ro"
                type="text"
                class="form-control compact-input"
                maxlength="100"
                :disabled="!form.is_active"
                :value="form.footer.ro"
                @input="updateI18nField('footer', 'ro', $event.target.value)"
            >
            <div class="compact-meta">
              <small class="compact-counter">
                {{ getLength(form.footer.ro) }} / 100
              </small>
              <small
                  v-if="isAtLimit(form.footer.ro)"
                  class="compact-error"
              >
                Ai atins limita maximă de 100 de caractere.
              </small>
            </div>
          </div>

          <div class="form-group col-12 col-md-6 compact-form-group mb-0">
            <label for="widget-carousel-footer-en" class="compact-label">EN</label>
            <input
                id="widget-carousel-footer-en"
                type="text"
                class="form-control compact-input"
                maxlength="100"
                :disabled="!form.is_active"
                :value="form.footer.en"
                @input="updateI18nField('footer', 'en', $event.target.value)"
            >
            <div class="compact-meta">
              <small class="compact-counter">
                {{ getLength(form.footer.en) }} / 100
              </small>
              <small
                  v-if="isAtLimit(form.footer.en)"
                  class="compact-error"
              >
                Ai atins limita maximă de 100 de caractere.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const STORE_NAMESPACE = 'widgetCarousel';

export default {
  name: 'WidgetCarouselTextSettings',

  props: {
    form: {
      type: Object,
      required: true
    }
  },

  methods: {
    updateI18nField(field, lang, value) {
      this.$store.dispatch(`${STORE_NAMESPACE}/updateI18nField`, {
        field,
        lang,
        value
      });
    },

    getLength(value) {
      return (value || '').length;
    },

    isAtLimit(value) {
      return this.getLength(value) >= 100;
    }
  }
};
</script>

<style scoped>
.compact-form-card__header {
  padding: 10px 14px;
  font-size: 14px;
}

.compact-form-card__body {
  padding: 14px;
}

.compact-form-row {
  margin-left: -6px;
  margin-right: -6px;
}

.compact-form-row > [class*='col-'] {
  padding-left: 6px;
  padding-right: 6px;
}

.compact-form-group {
  margin-bottom: 10px;
}

.compact-label {
  display: inline-block;
  margin-bottom: 5px;
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
}

.compact-input {
  height: 34px;
  padding: 6px 10px;
  font-size: 13px;
}

.compact-meta {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-top: 4px;
}

.compact-counter {
  font-size: 11px;
  line-height: 1.35;
  color: #6c757d;
  white-space: nowrap;
}

.compact-error {
  font-size: 11px;
  line-height: 1.35;
  color: #dc3545;
  text-align: right;
}

.widget-carousel-text-settings__section {
  margin-bottom: 18px;
}

.widget-carousel-text-settings__section-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
}

@media (max-width: 767.98px) {
  .compact-meta {
    flex-direction: column;
    align-items: flex-start;
  }

  .compact-error {
    text-align: left;
  }
}
</style>